<template>
  <label class="btn-file" :class="[dynamicPadding, { add: noImage }]">
    <input type="file" @change="readImage" ref="imageSelect" v-if="picture === ''" />
    <div class="view" :class="{ uploading: progress >= 0 && progress < 100 }">
      <svg v-if="picture === ''" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 31.444 31.444" style="enable-background:new 0 0 31.444 31.444;" xml:space="preserve">
        <path d="M1.119,16.841c-0.619,0-1.111-0.508-1.111-1.127c0-0.619,0.492-1.111,1.111-1.111h13.475V1.127  C14.595,0.508,15.103,0,15.722,0c0.619,0,1.111,0.508,1.111,1.127v13.476h13.475c0.619,0,1.127,0.492,1.127,1.111  c0,0.619-0.508,1.127-1.127,1.127H16.833v13.476c0,0.619-0.492,1.127-1.111,1.127c-0.619,0-1.127-0.508-1.127-1.127V16.841H1.119z" fill="#c6c6c6" />
      </svg>
      <a :href="picture" target="_blank" class="img-container" v-if="picture !== ''">
        <img :src="picture" class="preview" />
      </a>
      <!-- <img :src="picture" v-if="picture !== ''" class="preview"> -->
      <div class="progress-overlay" v-if="progress >= 0 && picture !== '' && progress < 100">
        <progress max="100" :value="progress" />
      </div>
      <div class="remove" v-if="picture !== '' && progress >= 100" @click.stop="onDelete">
        <i class="icon icon-cancel"></i>
      </div>
      <!-- <div class="progress" v-if="progress >= -5">{{progress}}</div> -->
    </div>
  </label>
</template>
<script>
import { mapActions } from "vuex";
// import utils from "../../plugins/api/utils/index.js";
export default {
  name: "FileUploader",
  props: {
    name: String,
    identify: String,
    oldSrc: String,
    index: Number,
    apiType: String
  },
  data() {
    return {
      picture: "",
      progress: -1
    };
  },
  computed: {
    dynamicPadding() {
      return this.picture !== "" ? "no-padding" : "";
    },
    noImage() {
      let pic = this.picture;
      if (pic && pic.length) return false;
      let src = this.oldSrc;
      if (src && src.length) return false;
      return true;
    }
  },
  watch: {
    oldSrc(newVal) {
      if (newVal) {
        this.picture = newVal;
        this.progress = 100;
      } else {
        this.picture = "";
        this.progress = -1;
      }
    }
  },
  mounted() {
    if (this.oldSrc) {
      this.picture = this.oldSrc;
      this.progress = 100;
    }
  },
  methods: {
    ...mapActions("agency", {
      processUploadAgency: "uploadImage"
    }),
    onClick() {},
    onDelete() {
      event.preventDefault();
      this.picture = "";
      this.$emit("delete", this.index);
    },
    readImage() {
      const files = this.$refs.imageSelect.files;
      if (files.length > 0) {
        this.$emit("startLoad");
        const image = files[0];
        let fread = new FileReader();
        fread.onload = evt => {
          this.picture = evt.target.result;
          this.uploadToServer(this.picture);
        };
        fread.onerror = () => {};
        fread.readAsDataURL(image);
      }
    },
    uploadToServer(base64) {
      let self = this;
      let config = {
        onUploadProgress(progressEvent) {
          self.progress = Math.round((((progressEvent.loaded * 100) / progressEvent.total) * 90) / 100);
        },
        onDownloadProgress(progressEvent) {
          self.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        }
      };

      if (this.apiType == "agency") {
        this.processUploadAgency({
          data: base64,
          config,
          onSuccess: res => {
            this.$emit("loaded", res.data.url, this.index);
          },
          onError: () => {
            this.progress = -1;
            this.onDelete();
          }
        });
      } else {
        this.processUploadAgency({
          data: base64,
          config,
          onSuccess: res => {
            this.$emit("loaded", res.data.url, this.index);
          },
          onError: () => {
            this.progress = -1;
            this.onDelete();
          }
        });
      }

      // utils.uploadImage(base64, config).then(res => {
      //   if (res.data && res.data.status === true) {
      //     this.$emit("loaded", res.data.url, this.index);
      //   }
      // }).catch(reason => {
      //   this.progress = -1;
      //   this.onDelete();
      // });
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-file {
  // Positioning
  @include flex-center(inline-flex);
  position: relative;
  align-self: flex-start;
  // Sizing
  $boxSize: 60px;
  width: $boxSize;
  height: $boxSize;
  transition: all 0.2s linear 0.15s;
  // padding: 4px;
  border-radius: $radius;
  // overflow: hidden;

  &.add {
    border: 1px dashed #c8c8c8;
  }

  .progress-overlay {
    @include flex-center;
    $size: 100%;
    max-width: $size;
    height: 100%;
    min-width: $size;
    position: absolute;
    z-index: 10;
    background-color: rgba(0, 0, 0, 0.329);
    // visibility: hidden;
    transition: all 0.2s;
    color: $cPrimary;
    font-size: 20px;
    // opacity: 0;
  }

  progress {
    margin-top: 8px;
    // margin-bottom: 2px;
    max-width: 90%;
    appearance: none;
    -webkit-appearance: none;
    height: 4px;
    transition: 0.4s;

    &::-webkit-progress-bar {
      background: $grey3;
      border-radius: 50px;
      padding: 0;
      transition: 0.4s;
      // box-shadow: 0 1px 0px 0 rgba(255, 255, 255, 0.2);
    }

    &::-webkit-progress-value {
      transition: 0.4s;
      background: $cSecondary1;
      border-radius: 2px;
    }
  }

  &:before {
    position: absolute;
    width: $boxSize;
    height: $boxSize;
    top: auto;
    left: auto;
    background-color: rgb(236, 0, 0);
    opacity: 0;
    transition: opacity 0.3s;
  }

  input[type="file"] {
    display: none;
  }

  div.view {
    @include flex-center;
    flex-flow: column;
    margin: 0;
    padding: 0;
    max-width: 100%;
    max-height: 100%;
    // height: 100%;
    position: relative;

    svg {
      $size: 20px;
      width: $size;
      height: $size;

      path {
        transition: all 0.2s linear 0.15s;
      }
    }

    .remove {
      @include flex-center;
      $size: 16px;
      max-width: $size;
      min-width: $size;
      height: $size;
      position: absolute;
      z-index: 10;
      // background-color: rgba(0, 0, 0, 0.329);
      visibility: hidden;
      @include trans-all;
      // color: $cPrimary;
      color: $light1;
      background: $textLightModeDisabled;
      font-size: 8px;
      opacity: 0;
      border-radius: 50%;
      border: 1px solid $light1;
      top: -8px;
      right: -8px;
      > i.icon {
        font-weight: 600;
      }
    }

    .img-container {
      max-width: 100%;
      @include flex-center;
      flex-direction: column;
      overflow: hidden;
      border-radius: $radius;
      max-height: 60px;
    }

    .preview {
      $size: 100%;
      max-width: $size;
      // min-height: $size;
      height: 100%;
      min-width: $size;
    }

    &.uploading .img-container {
      max-width: 100%;
    }

    &:hover {
      & > .remove {
        opacity: 1;
        visibility: visible;
      }
    }
  }

  &:not(:first-child) {
    margin-left: 16px;
    // margin-right: 0.5rem;
  }

  &:hover {
    cursor: pointer;
    border-color: $cPrimary;

    &::before {
      opacity: 1;
    }

    div {
      svg {
        path {
          fill: $cPrimary;
        }
      }
    }
  }

  &:focus,
  &:active,
  &:focus-within,
  &.animate-spin {
    div svg {
      animation-name: spin;
      animation-duration: 500ms;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
    }
  }
}
</style>
